import React from 'react';
import { useDispatch } from 'react-redux';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import { handleHtmlLoad, handleImageLoad } from '../../../../slices/templates/helper';
import DropFile from '../../../../Components/Common/DropFıle';
import { setUploadedFiles } from '../../../../slices/uploads/reducer';

function UploadCampaign({ limits = {} }) {
  const dispatch = useDispatch();

  async function loadFiles(files) {
    const filesArray = [];
    await Promise.all(
      files.map(async file => {
        if (limits.type === "image") {
          const extractedFiles = await handleImageLoad(file, limits.mimetypes);
          filesArray.push(...extractedFiles);
        } else if (limits.type === "html") {
          // try {
          //   // extractedFiles = await handleHtmlLoad(file, limits.mimetypes);
          // } catch (e) {
          // }
          let extractedFiles = [];
          filesArray.push(...extractedFiles);
        }
      })
    );
    dispatch(setUploadedFiles([...filesArray]));
  }

  return (
    <React.Fragment>
      <DropFile handleUpload={async (files) => await loadFiles(files)} size='lg' message='Drop files here or click to upload' />
    </React.Fragment>
  )
}

export default UploadCampaign;